import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonArrayOutputFormatting, getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createSystemMessage, createUserMessage } from '@/ai/utils/promptUtils'
import { buildWorkflowSpec, buildCardTypesMap } from '@/shared/utils/workflowSpec'
import { wrapUserInput } from '@/ai/utils/helpers'

export const buildWorkflowDiagramPrompt = ({ workflow, cardTypes, stream = true }) => {
  const messages = []

  const systemContent = buildPrompt([systemMessages.EVENT_MODELING_DDD_EXPERT])
  messages.push(createSystemMessage(systemContent))

  const promptSections = []

  promptSections.push({
    title: 'Request',
    content: [
      'This step represents the starting point of both Event Modeling and Event Storming: brainstorming domain events and arranging them on a timeline. Your task is to identify and list all state-changing Domain Events in chronological order, based on the provided Workflow Description (a business process or project scope). A state-changing Domain Event is the result of an actor (human role or Automation) invoking a state-changing command (create, update, or delete) on an aggregate. For each event, include the following:',
      '- **Role:** The actor invoking the command.',
      '    - If it\'s a human actor: use a short role name (e.g. Sales Rep, Customer, Courier).',
      '    - If it\'s automated: always use exactly the word Automation.',
      '    - Maximum length: 18 characters.',
      '- **Domain Event Description:** State-changing event written as aggregate name + past tense verb. Use spaces between words. Use Title Case (e.g. Order Placed, Cart Item Added, Payment Cancelled).',
      '    - The aggregate is the entity being created, updated, or deleted (business entity whose lifecycle state is being changed).',
      '    - Maximum length: 40 characters.'
    ]
  })

  promptSections.push({
    title: 'Workflow Description',
    flattenLines: false,
    content: wrapUserInput(workflow.aiDescription)
  })

  promptSections.push({
    title: 'Current Workflow Specification (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: buildWorkflowSpec(workflow, null, buildCardTypesMap(cardTypes)) || '{}'
  })

  const eventsObject = { events: examples.workflowDiagram }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: stream
      ? getJsonArrayOutputFormatting(JSON.stringify(examples.workflowDiagram))
      : getJsonOutputFormatting('events', JSON.stringify(eventsObject))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
